// Escala de Tasas

// La Renta imponible anual (UTA) desde/hasta se maneja en millones de pesos
const million = 1000000

export const rateScales = [
  {
    // Tramo
    section: 1,
    // Renta imponible anual (UTA)
    annualTaxableIncome: {
      from: 0,
      to: 13.5 * million,
    },
    factor: 0,
    // Cantidad a rebajar en %
    amountToBeReduced: 0,
  },
  {
    section: 2,
    annualTaxableIncome: {
      from: 13.5 * million,
      to: 30 * million,
    },
    factor: 0.04,
    amountToBeReduced: 0.54,
  },
  {
    section: 3,
    annualTaxableIncome: {
      from: 30 * million,
      to: 50 * million,
    },
    factor: 0.08,
    amountToBeReduced: 1.74,
  },
  {
    section: 4,
    annualTaxableIncome: {
      from: 50 * million,
      to: 70 * million,
    },
    factor: 0.135,
    amountToBeReduced: 4.49,
  },
  {
    section: 5,
    annualTaxableIncome: {
      from: 70 * million,
      to: 90 * million,
    },
    factor: 0.23,
    amountToBeReduced: 11.14,
  },
  {
    section: 6,
    annualTaxableIncome: {
      from: 90 * million,
      to: 120 * million,
    },
    factor: 0.304,
    amountToBeReduced: 17.8,
  },
  {
    section: 5,
    annualTaxableIncome: {
      from: 70 * million,
      to: 90 * million,
    },
    factor: 0.23,
    amountToBeReduced: 11.14,
  },
  {
    section: 6,
    annualTaxableIncome: {
      from: 90 * million,
      to: 120 * million,
    },
    factor: 0.304,
    amountToBeReduced: 17.8,
  },
  {
    section: 7,
    annualTaxableIncome: {
      from: 120 * million,
      to: 310 * million,
    },
    factor: 0.35,
    amountToBeReduced: 23.32,
  },
  {
    section: 8,
    annualTaxableIncome: {
      from: 310 * million,
      to: Infinity,
    },
    factor: 0.4,
    amountToBeReduced: 38.82,
  },
]

export const defaultValues = {
  ticketFees: '',
  taxableIncomeRental: '',
  taxableIncomeInvestments: '',
  otherTaxableIncomes: '',
  firstname: '',
  email: '',
  phone: '',
}

export const inputs = [
  {
    type: 'text',
    name: 'ticketFees',
    label: 'Boletas honorarios 2023 (bruto)',
    placeholder: '0.00',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'resume',
    resumeKey: 'billsAndFees',
  },
  {
    type: 'text',
    name: 'taxableIncomeRental',
    label: 'Renta imponible arriendo',
    placeholder: '0.00',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'taxableIncomeInvestments',
    label: 'Renta imponible inversiones',
    placeholder: '0.00',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'text',
    name: 'otherTaxableIncomes',
    label: 'Otras renta imponibles',
    placeholder: '0.00',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'resume',
    resumeKey: 'taxableIncomes',
  },
  {
    type: 'text',
    name: 'firstname',
    label: 'Escribe tu nombre y apellido',
    placeholder: 'Usuario',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'email',
    name: 'email',
    label: 'Escribe tu correo electrónico',
    placeholder: 'usuario@correo.com',
    isRequired: true,
    className: 'col-span-2',
  },
  {
    type: 'number',
    name: 'phone',
    label: 'Teléfono de contacto',
    placeholder: '56 5555 555 555',
    isRequired: true,
    className: 'col-span-2',
  },
]
